import React, { forwardRef } from "react";
import FindingDetailsModalV3 from "./ModalV3";

const FindingDetailsPopup = forwardRef(function FindingDetailsPopup(
  props,
  ref
) {
  return <FindingDetailsModalV3 {...props} ref={ref} />;
});

export default FindingDetailsPopup;
